import {sendRequest} from '../axios'

export default {
    state: {
        menu: [],
        url: '/mywins'
    },
    mutations: {
        SET_URL(state,payload) {
            state.url = payload;
        },
        SET_MENU(state,payload) {
            state.menu = payload
        },
        CLEAR_MENU(state) {
            state.menu = [];
        }
    },
    actions: {
        // getMenu({commit}) {
        //     return new Promise((resolve, reject) => {
        //         commit('SET_PROCESSING',true);
        //         sendRequest('/api/getMenuArray','get')
        //           .then(response => {
        //             const items = response.data.items;
        //             //const url = response.data.url;
        //             //const url = ""; //не нужно нам больше этого - перехода в конкретный пункт меню.
        //             // const url = localStorage.getItem('url');
        //             const url = localStorage.getItem('url') || response.data.url || '/myorganisation' //response.data.url !== '' && response.data.url !== undefined ? response.data.url : localStorage.getItem('url')=== undefined && localStorage.getItem('url') === null ? '/myorganisation':localStorage.getItem('url')

        //             const parsed = JSON.stringify(items);

        //             localStorage.setItem('menu', parsed)
        //             //localStorage.setItem('url', url)

        //             // commit('SET_MENU',{items,url});

        //             // if (url) {
        //                 // commit('SET_MENU',{items,url});
        //             // } else {
        //             //     const url2 = "/myorganisation";
        //             //     commit('SET_MENU',{items,url2});
        //             // }

        //             commit('SET_PROCESSING',false);
        //             resolve(response)
        //           })
        //       })
        // },
        clearMenu({commit}) {
            commit('CLEAR_MENU');
            localStorage.removeItem('menu');
            localStorage.removeItem('url');
        },
        // setMenu({commit}, payload) {
        //     commit('SET_MENU',payload)
        // }
    },
    getters: {
        getMenuItems: (state) => state.menu,
        getMenuUrl: (state) => state.url,
    }
}
